import styled from "styled-components";
export const FocusList = styled.div `
  position: relative;
`;
